export default {
  en_us: {
    getMessages: () => import(/* webpackChunkName: "lang_en_us" */ './translations/split/en_us.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_en" */ 'react-intl/locale-data/en'),
  },
  en: {
    getMessages: () => import(/* webpackChunkName: "lang_en_us" */ './translations/split/en_us.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_en" */ 'react-intl/locale-data/en'),
  },
  en_gb: {
    getMessages: () => import(/* webpackChunkName: "lang_en_us" */ './translations/split/en_us.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_en" */ 'react-intl/locale-data/en'),
  },
  en_ca: {
    getMessages: () => import(/* webpackChunkName: "lang_en_us" */ './translations/split/en_us.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_en_us" */ 'react-intl/locale-data/en'),
  },
  es: {
    getMessages: () => import(/* webpackChunkName: "lang_es" */ './translations/split/es.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_es" */ 'react-intl/locale-data/es'),
  },
  es_es: {
    getMessages: () => import(/* webpackChunkName: "lang_es" */ './translations/split/es.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_es" */ 'react-intl/locale-data/es'),
  },
  fr: {
    getMessages: () => import(/* webpackChunkName: "lang_fr" */ './translations/split/fr.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_fr" */ 'react-intl/locale-data/fr'),
  },
  fr_ca: {
    getMessages: () => import(/* webpackChunkName: "lang_fr" */ './translations/split/fr.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_fr" */ 'react-intl/locale-data/fr'),
  },
  de: {
    getMessages: () => import(/* webpackChunkName: "lang_de" */ './translations/split/de.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_de" */ 'react-intl/locale-data/de'),
  },
  pt: {
    getMessages: () => import(/* webpackChunkName: "lang_pt" */ './translations/split/pt.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_pt" */ 'react-intl/locale-data/pt'),
  },
  ar: {
    getMessages: () => import(/* webpackChunkName: "lang_ar" */ './translations/split/ar.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ar" */ 'react-intl/locale-data/ar'),
  },
  he: {
    getMessages: () => import(/* webpackChunkName: "lang_he" */ './translations/split/he.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_he" */ 'react-intl/locale-data/he'),
  },
  af: {
    getMessages: () => import(/* webpackChunkName: "lang_af" */ './translations/split/af.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_af" */ 'react-intl/locale-data/af'),
  },
  bg: {
    getMessages: () => import(/* webpackChunkName: "lang_bg" */ './translations/split/bg.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_bg" */ 'react-intl/locale-data/bg'),
  },
  bs: {
    getMessages: () => import(/* webpackChunkName: "lang_bs" */ './translations/split/bs.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_bs" */ 'react-intl/locale-data/bs'),
  },
  ca: {
    getMessages: () => import(/* webpackChunkName: "lang_ca" */ './translations/split/ca.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ca" */ 'react-intl/locale-data/ca'),
  },
  cs: {
    getMessages: () => import(/* webpackChunkName: "lang_cs" */ './translations/split/cs.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_cs" */ 'react-intl/locale-data/cs'),
  },
  da: {
    getMessages: () => import(/* webpackChunkName: "lang_da" */ './translations/split/da.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_da" */ 'react-intl/locale-data/da'),
  },
  nl: {
    getMessages: () => import(/* webpackChunkName: "lang_nl" */ './translations/split/nl.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_nl" */ 'react-intl/locale-data/nl'),
  },
  el: {
    getMessages: () => import(/* webpackChunkName: "lang_el" */ './translations/split/el.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_el" */ 'react-intl/locale-data/el'),
  },
  et: {
    getMessages: () => import(/* webpackChunkName: "lang_et" */ './translations/split/et.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_et" */ 'react-intl/locale-data/et'),
  },
  fi: {
    getMessages: () => import(/* webpackChunkName: "lang_fi" */ './translations/split/fi.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_fi" */ 'react-intl/locale-data/fi'),
  },
  fil: {
    getMessages: () => import(/* webpackChunkName: "lang_fil" */ './translations/split/fil.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_fil" */ 'react-intl/locale-data/fil'),
  },
  hi: {
    getMessages: () => import(/* webpackChunkName: "lang_hi" */ './translations/split/hi.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_hi" */ 'react-intl/locale-data/hi'),
  },
  hr: {
    getMessages: () => import(/* webpackChunkName: "lang_hr" */ './translations/split/hr.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_hr" */ 'react-intl/locale-data/hr'),
  },
  hu: {
    getMessages: () => import(/* webpackChunkName: "lang_hu" */ './translations/split/hu.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_hu" */ 'react-intl/locale-data/hu'),
  },
  id: {
    getMessages: () => import(/* webpackChunkName: "lang_id" */ './translations/split/id.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_id" */ 'react-intl/locale-data/id'),
  },
  is: {
    getMessages: () => import(/* webpackChunkName: "lang_is" */ './translations/split/is.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_is" */ 'react-intl/locale-data/is'),
  },
  it: {
    getMessages: () => import(/* webpackChunkName: "lang_it" */ './translations/split/it.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_it" */ 'react-intl/locale-data/it'),
  },
  ja: {
    getMessages: () => import(/* webpackChunkName: "lang_ja" */ './translations/split/ja.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ja" */ 'react-intl/locale-data/ja'),
  },
  ka: {
    getMessages: () => import(/* webpackChunkName: "lang_ka" */ './translations/split/ka.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ka" */ 'react-intl/locale-data/ka'),
  },
  ko: {
    getMessages: () => import(/* webpackChunkName: "lang_ko" */ './translations/split/ko.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ko" */ 'react-intl/locale-data/ko'),
  },
  lt: {
    getMessages: () => import(/* webpackChunkName: "lang_lt" */ './translations/split/lt.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_lt" */ 'react-intl/locale-data/lt'),
  },
  lv: {
    getMessages: () => import(/* webpackChunkName: "lang_lv" */ './translations/split/lv.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_lv" */ 'react-intl/locale-data/lv'),
  },
  no: {
    getMessages: () => import(/* webpackChunkName: "lang_no" */ './translations/split/no.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_no" */ 'react-intl/locale-data/no'),
  },
  pl: {
    getMessages: () => import(/* webpackChunkName: "lang_pl" */ './translations/split/pl.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_pl" */ 'react-intl/locale-data/pl'),
  },
  pt_br: {
    getMessages: () => import(/* webpackChunkName: "lang_pt_br" */ './translations/split/pt_br.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_pt" */ 'react-intl/locale-data/pt'),
  },
  ro: {
    getMessages: () => import(/* webpackChunkName: "lang_ro" */ './translations/split/ro.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ro" */ 'react-intl/locale-data/ro'),
  },
  ru: {
    getMessages: () => import(/* webpackChunkName: "lang_ru" */ './translations/split/ru.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ru" */ 'react-intl/locale-data/ru'),
  },
  sk: {
    getMessages: () => import(/* webpackChunkName: "lang_sk" */ './translations/split/sk.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sk" */ 'react-intl/locale-data/sk'),
  },
  sl: {
    getMessages: () => import(/* webpackChunkName: "lang_sl" */ './translations/split/sl.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sl" */ 'react-intl/locale-data/sl'),
  },
  sq: {
    getMessages: () => import(/* webpackChunkName: "lang_sq" */ './translations/split/sq.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sq" */ 'react-intl/locale-data/sq'),
  },
  sr: {
    getMessages: () => import(/* webpackChunkName: "lang_sr" */ './translations/split/sr.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sr" */ 'react-intl/locale-data/sr'),
  },
  sr_me: {
    getMessages: () => import(/* webpackChunkName: "lang_sr_me" */ './translations/split/sr_me.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sr" */ 'react-intl/locale-data/sr'),
  },
  sv: {
    getMessages: () => import(/* webpackChunkName: "lang_sv" */ './translations/split/sv.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sv" */ 'react-intl/locale-data/sv'),
  },
  sw: {
    getMessages: () => import(/* webpackChunkName: "lang_sw" */ './translations/split/sw.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_sw" */ 'react-intl/locale-data/sw'),
  },
  th: {
    getMessages: () => import(/* webpackChunkName: "lang_th" */ './translations/split/th.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_th" */ 'react-intl/locale-data/th'),
  },
  tr: {
    getMessages: () => import(/* webpackChunkName: "lang_tr" */ './translations/split/tr.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_tr" */ 'react-intl/locale-data/tr'),
  },
  tw: {
    getMessages: () => import(/* webpackChunkName: "lang_tw" */ './translations/split/tw.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_ak" */ 'react-intl/locale-data/ak'),
  },
  uk: {
    getMessages: () => import(/* webpackChunkName: "lang_uk" */ './translations/split/uk.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_uk" */ 'react-intl/locale-data/uk'),
  },
  vi: {
    getMessages: () => import(/* webpackChunkName: "lang_vi" */ './translations/split/vi.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_vi" */ 'react-intl/locale-data/vi'),
  },
  zh_cn: {
    getMessages: () => import(/* webpackChunkName: "lang_zh_cn" */ './translations/split/zh_cn.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_zh" */ 'react-intl/locale-data/zh'),
  },
  zh_tw: {
    getMessages: () => import(/* webpackChunkName: "lang_zh_tw" */ './translations/split/zh_tw.json'),
    getLocaleData: () => import(/* webpackChunkName: "locale_zh" */ 'react-intl/locale-data/zh'),
  },
};
